var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"w-nav",attrs:{"type":"dark"}},[_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('b-navbar-nav',[_c('RightNavItems')],1),_c('b-navbar-nav',{staticClass:"mr-auto"},[_c('LeftNavItams')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }